import {Component, OnInit, OnDestroy, inject} from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../components/navbar/navbar.component';
import { NavtabsComponent } from '../components/navtabs/navtabs.component';
import { TranslationService } from '../service/translation.service';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-compromise-reports',
    templateUrl: './compromise-reports.component.html',
    styleUrls: ['./compromise-reports.component.scss'],
      providers: [TranslationService],
    imports: [CommonModule, RouterModule, NavbarComponent, NavtabsComponent],
    standalone: true
})
export class CompromiseReportsComponent implements OnInit, OnDestroy{

  private readonly translationService = inject(TranslationService);

  constructor() {}

  ngOnDestroy(): void {
    document.body.style.backgroundColor="white";
  }
  ngOnInit(): void {
   
    this.translationService.get('menu-compromise-reports').subscribe((translation) => {
      document.title = `DIP - ${translation}`;
    });
    document.body.style.backgroundColor="#F1F1F4";
  }
}
